import request from '@/utils/request'


// 查询群聊列表
export function listGroup(query) {
  return request({
    url: '/user/group/list',
    method: 'get',
    params: query
  })
}

// 查询群聊分页
export function pageGroup(query) {
  return request({
    url: '/user/group/page',
    method: 'get',
    params: query
  })
}

// 查询群聊详细
export function getGroup(data) {
  return request({
    url: '/user/group/detail',
    method: 'get',
    params: data
  })
}


export function goGroup(data) {
  return request({
    url: '/user/group/goGroup',
    method: 'post',
    data: data
  })
}

export function disbandGroup(data) {
  return request({
    url: '/user/group/disbandGroup',
    method: 'post',
    data: data
  })
}
// 新增群聊
export function addGroup(data) {
  return request({
    url: '/user/group/add',
    method: 'post',
    data: data
  })
}

// 修改群聊
export function updateGroup(data) {
  return request({
    url: '/user/group/edit',
    method: 'post',
    data: data
  })
}

// 删除群聊
export function delGroup(data) {
  return request({
    url: '/user/group/delete',
    method: 'post',
    data: data
  })
}
